import React from "react";

export default function LoadingSpinner({
  size = 24,
  thickness = 3,
  color = "var(--Fresh-Blue, #5AC9E7)",
  speedMs = 900,
}) {
  const radius = (size - thickness) / 2;
  const circumference = Math.PI * radius / 2; // 90°

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{
        animation: `spin ${speedMs}ms linear infinite`,
      }}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={thickness}
        strokeLinecap="round"
        strokeDasharray={`${circumference} 999`}
      />

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </svg>
  );
}
